<template>
  <div class="video-box">
    <popUp v-if="popUpToggle" v-on:doClose="close" :size="'middle'">
      <div class="pop-title" slot="title">
        <h2 style="font-weight: bold;">看更多</h2>
      </div>
      <div slot="info" class="info-main" >
        <ul class="list-group list-group-flush">
          <li v-for="item in lessonList" @click="goCoursePage(item.id)" :key="item.id" class="list-group-item  list-group-item-action d-flex  align-items-center justify-content-between pointer" :class="{'current' : item.id == lessonId}">
            <span >
              <div style="font-size: 1.5rem;">
                {{ item.name }}
              </div>
              <div v-if="item.name_en" style="font-size: .8rem;" v-html="forceToJap(item.name_en)"></div>
            </span>
            <div>
              <img class="my-auto mx-1" v-if="item.is_read" style="width:25px; height:25px" src="../assets/image/icon&btn/icon_other/icon_read_G.png" alt="">
              <img class="my-auto mx-1" v-if="item.is_pass" style="width:25px; height:25px" src="../assets/image/pic/icon_class_video_complete.png" alt="">
            </div>
          </li>
        </ul>
      </div>
    </popUp>
    <div class="d-flex">
      <div class="navbar_l pointer" @click.self="navbarToggle" :class="{'active_l': !toggle}">
        <ul class="list-group p-0">
          <li v-for="(item, index) in videoData" @click="goLesson(item,index)" :key="index"  class="list-group-item list-group-item-action m-0 px-0 pointer" :class="{'current' : !aiMode && current === index}">
            <img class="icon" v-if="item.type ==='live_course'"  src="../assets/image/icon&btn/icon_have_btn_function/btn_sideFunction_interactive.png" alt="">
            <img class="icon" v-if="item.type ==='video'" src="../assets/image/icon&btn/icon_have_btn_function/btn_sideFunction_video.png" alt="">
            <img class="icon" v-if="item.type ==='practice'" src="../assets/image/icon&btn/icon_have_btn_function/btn_sideFunction_test.png" alt="">
            <br>
            <span v-if="item.type ==='live_course'">
              互動課程
            </span>
            <span v-if="item.type ==='video'">
              名師講解
            </span>
            <span v-if="item.type === 'practice'">
              測驗
            </span>
          </li>
          <li class="list-group-item list-group-item-action m-0 px-0 pointer text-black" v-if="view_id" @click="goAiCourse" :class="{'current': aiMode}">
            <div class="d-block">
              <img class="icon" src="../assets/image/icon&btn/icon_have_btn_function/btn_sideFunction_chat.png" alt=""><br>
              <span>AI 口說挑戰</span>
            </div>
          </li>
          <li @click="goPage" class="list-group-item list-group-item-action m-0 px-0 pointer"><img class="icon" src="../assets/image/icon&btn/icon_have_btn_function/btn_more.png" alt=""><br><span>看更多</span></li>
          <li @click="$router.back()" class="list-group-item list-group-item-action m-0 px-0 pointer"><img class="icon" src="../assets/image/icon&btn/icon_have_btn_function/btn_sideFunction_home.png" alt=""><br><span>返回</span></li>
        </ul>
        <div class="collapse-icon" :class="{'rotate':!toggle}">
          <!-- {{videoData[0].data.path}} -->
          <font-awesome-icon @click.self="navbarToggle" class="pointer chevron" size="lg" :icon="['fa', 'chevron-right']"  style="color:rgba(0, 0, 0, .2)"/>
        </div>
      </div>
      <div class="video mx-auto" style="width:100%;max-width: 1280px!important;min-width: 320px!important;min-height:980px" >
        <div class="m-3" style="text-align:left">
          <img class="pointer" style="float:right;width:40px" v-if="favorite" @click="removeCollections(lessonId)" src="../assets/image/pic/btn_function_mark_on.png" alt="">
          <img class="pointer" style="float:right;width:40px" v-else @click="addCollections(lessonId)" src="../assets/image/pic/btn_function_mark_off.png" alt="">
          <img class="pointer rwd-more" style="float:right;width:40px;padding:5px" @click="getLessonList" src="../assets/image/icon&btn/icon_have_btn_function/btn_more.png" alt="">
          <h3>
            {{this.titleName.name}}
          </h3>
          <h6 v-html="forceToJap(this.titleName.name_en)"></h6>
          <div v-if="videoData.length || view_id" class="btn-group mt-2 rwd-list" role="group">
            <button
              v-for="(item, index) in videoData"
              :key="index"
              type="button"
              class="btn btn-outline-secondary"
              :class="{'active' : !aiMode && current === index}"
              @click="goLesson(item, index)"
            >
              {{ getClassTypeName(item.type) }}
            </button>
            <button
              v-if="view_id"
              type="button"
              class="btn btn-outline-secondary"
              :class="{'active' : aiMode}"
              @click="goAiCourse"
            >
              AI 口說挑戰
            </button>
          </div>
        </div>
        <div v-if="aiMode && view_id" class="m-3">
          <AICourse v-if="aiCourseType === 'ai_chat'" :course-id="view_id" />
          <AiShadowChat v-else-if="aiCourseType === 'ai_follow'" :view_id="view_id" />
        </div>
        <div v-else v-for="(item, index) in videoData" :key="index" >
          <div>
            <div v-if="lesson && current===index && classType === 'live_course'">
              <live-player :moduleEnable="['video', 'detail' ,'article', 'ebook', 'text', 'practice' , 'reading' ,'vocabulary']" v-on:updatedVideoState="updatedVideoState" v-if="item.type === 'live_course' || item.type === 'practice'" :liveData="lesson" :articleImg="cover" :sectionId="sectionId" />
            </div>
            <player style="width:100%; background:black; height:50vh" v-on:updatedVideoState="updatedVideoState" v-if="item.type ==='video'&& current===index" class="m-auto" :url="item.data.path"/>
          </div>
          <div v-if=" classType === 'practice'">
            <practice :key="sectionId" :sectionId="sectionId" style="width:85%" v-if="item.type ==='practice'&& current===index" class="page mx-auto py-5" :setNoticePage="true" :quests="JSON.parse($store.state.videoData[current].data.questions).practices" v-on:score="handlerPracticeScore" :passRate="config.practice ? config.practice.passRate : -1">
            </practice>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="lesson.modules[0]">
      <Assist :assistData="lesson.modules[0].vocabularies" />
    </div> -->
  </div>
</template>

<script>
import api from '../store/api'
// import libraryApi from '../store/library/api'
import LivePlayer from 'live-player'
import Assist from '../components/Assist'
import AICourse from './AiHelper/course/Corse.vue'
import AiShadowChat from './AiHelper/AiShadowChat.vue'
import Player from 'live-player/dist/Player'
import Practice from 'live-player/dist/Practice'
import Exam from 'live-player/dist/Exam'
import popUp from '../components/PopUp.vue'
import { mapActions, mapGetters } from 'vuex'
import { param } from 'jquery'
export default {
  name: 'CourseLesson',
  data () {
    return {
      cover: null,
      favorite: false,
      timer: null,
      time: 0,
      toggle: true,
      popUpToggle:false,
      lesson: null,
      lessonList: [],
      current: 0,
      aiMode: false,
      period: 60,
      idle: 10,
      parentId: 0,
      state: 'stop',
      classType: null,
      view_id: null,
      aiCourseType: null
    }
  },
  components: {
    LivePlayer,
    Player,
    Practice,
    Assist,
    AICourse,
    AiShadowChat,
    Exam,
    popUp
  },
  props: {
    config: {
      type: Object,
      required: false,
      default: () => {
        return {
          practice: {
            noticePage: false,
            passRate: -1
          }
        }
      }
    },
    idleTime: {
      type: Number,
      required: true
    },
  },
  computed: {
    ...mapGetters([
      'videoData',
      'titleName'
    ]),
    sectionId () {
      return this.videoData[this.current].id
    },
    lessonId () {
      return this.$route.params.lesson
    }
  },
  watch: {
    current () {
      this.recordTime(this.time)
      this.time = 0
      this.getLesson(this.$route.params.courseId)
    },
    time (val) {
      if (val === this.period) {
        this.recordTime(val)
        this.time = 0
      }
    },
    state (val) {
      if (val === 'playing') {
        this.$emit('isIdle', 'playing')
      } else {
        this.$emit('isIdle', 'stop')
      }
    }
  },
  async beforeDestroy () {
    this.recordTime(this.time)
    this.$emit('isIdle', 'stop')
    clearInterval(this.timer)
  },
  async mounted () {
    this.getLessonId(this.lessonId)
    this.timer = setInterval(this.countUp, 1000)
    this.scrollTop()
    await this.getVideo(this.$route.params.lesson)
    this.classType = this.videoData[0] ? this.videoData[0].type : null
    if (this.videoData[this.current].type === 'live_course') {
      this.getLesson(this.$route.params.courseId)
    }
  },
  methods: {
    ...mapActions([
      'getVideo'
    ]),
    navbarToggle () {
      this.toggle = !this.toggle
    },
    async getLesson (id) {
      const { data } = await api.get(`/contents/lesson/${id}`)
      if (data.status === 'OK') {
        this.lesson = data.data
      }
    },
    getClassTypeName (type) {
      const typeNameMap = {
        live_course: '互動課程',
        video: '名師講解',
        practice: '測驗'
      }
      return typeNameMap[type] || ''
    },
    goLesson (item,idex) {
      this.classType = item.type || (this.videoData[idex] ? this.videoData[idex].type : null)
      this.aiMode = false
      this.current = idex
    },
    goAiCourse () {
      this.aiMode = true
      this.state = 'stop'
    },
    updatedVideoState (val) {
      this.state = val
    },
    goPage () {
      this.$router.push({ name: 'Course', params: { channel: this.parentId } })
    },
    handlerPracticeScore (score) {
      this.$emit('practiceScore', score)
    },
    countUp() {
      if (this.state === 'playing') {
        this.time ++
      } else {
        if (this.idleTime < this.idle*60  ) {
          this.time ++
        } else if (this.idleTime === this.idle*60) {
          this.$swal({
            title: `Hello同學，歡迎繼續上課🙂`,
            text: `溫馨提醒:您已閒置超過${this.idle}分鐘，請點擊下方按鈕回到課程`,
            icon: 'info',
            showCancelButton: false,
            confirmButtonText: '確定'
          })
        }
      }
    },
    async recordTime (val) {
      const options = { headers: {'showLoading': false }}
      const fileData = new window.FormData()
      fileData.append('seconds', val)
      const { data } = await api.post(`records/section/${this.sectionId}/time`, fileData, options)
    },
    async getLessonId (id) {
      const { data } = await api.get(`/contents/courses/${id}`)
      if (data.status === 'Success') {
        this.favorite = data.data.is_favorite
        this.parentId = data.data.package_course.id
        this.cover = data.data.cover
        const aiCourseSection = data.data.sections.find(item => item.type === 'ai_chat' || item.type === 'ai_follow')
        this.view_id = aiCourseSection ? (aiCourseSection.data.view_id || null) : null
        this.aiCourseType = aiCourseSection ? aiCourseSection.type : null
        return data.data
      }
    },
    async getLessonList () {
      const { data } = await api.get(`/contents/package_courses/${this.parentId}/list`)
      if (data.status === 'Success') {
        this.lessonList = data.data
        this.popUpToggle = true
      }
    },
    async addCollections (el) {
      await this.getLessonId(el).then((val) => {
        try {
          const json = {
            banner: val.package_course.banner,
            view_id: val.sections[0].data.view_id||val.sections[0].id
          }
          const fileData = new window.FormData()
          fileData.append('json', JSON.stringify(json))
          fileData.append('view_id', val.sections[0].data.view_id||val.sections[0].id)
          api.post(`collections/course/${el}`, fileData).then((res)=> {
            if (res.status === 200) {
              this.getLessonId(el)
            }
          })
        } catch (error) {
          console.error(error.response.data)
        }
      })
    },
    async removeCollections (el) {
      await api.delete(`collections/course/${el}`).then((res)=> {
        if (res.status === 200) {
          this.getLessonId(el)
        }
      })
    },
    async goCoursePage (id) {
      await this.getLessonId(id).then((val) => {
        this.$router.push({ name: 'CourseLesson', params: { lesson: val.id, courseId: val.sections[0].data.view_id||val.sections[0].id } })
      } )
    },
    close (close) {
      this.popUpToggle = close
    },
    forceToJap (sent, hidePinyin = false) {
      if (typeof sent !== 'string') return ''
      const split = sent.split(/{(.+?)}/)
      let newSent = ''
      for (const i in split) {
        if (split[i].indexOf('=') > -1) {
          if (!hidePinyin) {
            newSent += '<ruby>' + split[i].split(/=/)[0] + '<rt>' + split[i].split(/=/)[1] + '</rt></ruby>'
          } else {
            newSent += split[i].split(/=/)[0]
          }
        } else {
          newSent += split[i]
        }
      }
      return newSent
    },
    scrollTop () {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
        if (currentScroll > 0) {
          window.scrollTo(0, 0)
        }
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/styles/LivePlayer.css';
@import "../assets/styles/color.scss";
  .video-box {
    background: #eaedf2;
    min-height: calc(100vh - 113px) !important;
  }
  .navbar_l {
    position: relative;
    min-height: calc(100vh - 113px)  !important;
    border: 1px solid rgb(207, 205, 205);
    ul {
      text-align: center;
      padding: 10px;
      white-space:nowrap;
      list-style-type: none;
      overflow: hidden;
      li {
        font-weight: 800;
        margin: 10px 0;
      }
    }
    width: 150px;
    background-color: rgb(255, 255, 255) !important;
    transition: all .5s cubic-bezier(0.25,0.1,0.25,1);
    opacity: 1;
  }
  .active_l {
    width: 65px;
    span {
      opacity: 0;
    }
  }
  .icon {
    width: 35px;
  }
  .hide {
    display: none;
  }
  .rwd-list {
    display: none;
  }
  .collapse-icon {
    position: absolute;
    transition: all .5s cubic-bezier(0.25,0.1,0.25,1);
    top:50%;
    right: 5%;
    transform: translate(-50%, -50%);
    transform: rotate(900deg);
  }
  .rotate {
    transform: rotate(0deg);
  }
  .current  {
    background-color: rgb(238, 238, 238) !important;
  }
  .rwd-more {
    display: none;
  }
  @media (max-width: 480px) {
    .navbar_l {
      display: none;
    }
    .rwd-list {
      button:active,button:focus {
        outline: none !important;
        box-shadow: none !important;
      }
      display: flex;
    }
  }
  @media (max-width: 480px) {
    .rwd-more {
      display: block;
    }
  }
  a {
    color: #495057 !important;
    &:hover {
      text-decoration: none !important;
    }
  }
  .ai-course-box {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    background: #fff;
  }
  .ai-course-title {
    font-size: 1.1rem;
    font-weight: 700;
  }
  .ai-course-desc {
    font-size: .9rem;
    color: #6c757d;
    margin-top: 2px;
  }
</style>
